import type { ChatMessage } from '@afra/shared'
import { ConversationText } from './ConversationText'
export { ConversationText } from './ConversationText'

/**
 * The stored conversation, as bubbles and tool lines. Shared by the live chat
 * and the archive, so an archived conversation reads exactly as it did.
 */
export function Transcript({ messages }: { messages: ChatMessage[] }) {
  return (
    <>
      {messages.map((message) =>
        message.kind === 'tool' ? (
          <ToolLine key={message.id} message={message} />
        ) : (
          <div
            key={message.id}
            className={`msg ${message.from === 'agent' ? 'msg--agent' : 'msg--org'} ${message.hypothesisId ? 'msg--guess' : ''}`}
          >
            {/* A guess put to the director is marked as one, so it reads as a
                question about their organization to agree or disagree with,
                not as something the agent has concluded. */}
            {message.hypothesisId && <div className="msg__kind">حدس افرا · تأیید می‌کنید؟</div>}
            <ConversationText text={message.textFa} />
            {message.from === 'agent' && (
              <div className="msg__meta">
                <span
                  className={`badge ${message.generated ? 'badge--generated' : 'badge--stored'}`}
                  title={message.model ?? 'متن ثابت، بدون مدل'}
                >
                  {message.generated ? 'نوشتهٔ مدل' : 'متن ثابت'}
                </span>
              </div>
            )}
          </div>
        ),
      )}
    </>
  )
}

/**
 * One thing the agent did, between one sentence and the next.
 *
 * Shown by default. Afra can turn this off for charities from the admin
 * surface, and staff see them either way — but the default is on, because an
 * agent that writes to your ledger while it talks to you should be visibly
 * doing so.
 */
export function ToolLine({ message }: { message: ChatMessage }) {
  return (
    <div className={`tool-line ${message.toolFailed ? 'tool-line--failed' : ''}`}>
      <span>{message.toolSummaryFa}</span>
      <span className="tool-line__name ltr">{message.toolName}</span>
      {message.toolFailed && <span className="badge badge--bad">انجام نشد</span>}
    </div>
  )
}
